import React from "react";

const Hero = () => {
    return (
        <div className="flex items-center justify-center ">
            <div className="flex flex-col items-center justify-center gap-2">
                <p className="red">Admin's Access Only</p>
                <h1 className="text-5xl black font-normal">
                    Welcome to <span className="mainred font-semibold">Ai</span>
                    <span className="mainblue font-semibold">Mantra</span> Admin
                    Panel
                </h1>
            </div>
        </div>
    );
};

export default Hero;
